import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {lighten, desaturate} from 'polished/lib/index'

const Text = ({id, onChange, value, borderColor = '#898989', inputStyle = 'default', disabled = false, autoComplete}) => {
    let theme = ''
    switch (inputStyle) {
        case 'small':
            theme = smallTheme
            break
        case 'default':
        default:
            theme = defaultTheme
    }

    return (
        <Input
            type={'text'}
            id={id}
            onChange={onChange}
            value={value}
            color={borderColor}
            theme={theme}
            disabled={disabled}
            autoComplete={autoComplete && autoComplete}/>
    )
}

Text.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    borderColor: PropTypes.string,
    theme: PropTypes.oneOf(['small', 'default']),
    disabled: PropTypes.bool,
    autoComplete: PropTypes.oneOf(['off']),
}

export default Text

const smallTheme = {
    padding: '.3rem .75rem',
    marginTop: '0',
    width: 'auto'
}

const defaultTheme = {
    padding: '.5rem .75rem',
    marginTop: '5px',
    width: '100%'
}

const Input = styled.input`
    display: block;
    width: ${props => props.theme.width};
    padding: ${props => props.theme.padding};
    font-size: 1rem;
    line-height: 1.25;
    box-shadow: inset 0 1px 2px rgba(0,0,0,0.02), inset 0 1px 1px rgba(0,0,0,0.06), 0px 0px 3px 1px rgba(0,0,0,0);
    border-radius: 3px;
    font-weight: 200;
    outline: 0;
    box-sizing: border-box;
    margin-top: ${props => props.theme.marginTop};
    border: 1px solid ${props => props.color && props.color};
    color: ${props => props.disabled ? desaturate(0.5, lighten(0.4, '#555555')) : '#555555'}; 
    ${props => props.disabled && 'cursor: not-allowed;'}
    transition: border .5s ease, box-shadow 0.5s ease;
    &:focus {
        box-shadow: inset 0 1px 2px rgba(0,0,0,0), inset 0 1px 1px rgba(0,0,0,0), 0px 0px 5px 1px rgba(11, 95, 153,0.15);
    }
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Atoms/Text.jsx